import React, { Component } from 'react'
import { getUserRealTime, getCurrentUser } from '../firebase/obj/user'
import { CircularProgress } from '@material-ui/core'

export default class DeliveryWalletWithData extends Component {
    constructor() {
        super()
        this.state = {
            user: null,
        }
    }


    loadUser() {
        const _this = this
        getUserRealTime(getCurrentUser(), user => {
            _this.setState({
                user
            })
        })
    }

    componentDidMount() {
        this.loadUser()
    }


    render() {
        return (
            <React.Fragment>
                {
                    this.state.user ?
                        <div style={{ fontWeight: 'bold' }}>
                            {`$ ${this.state.user.wallet || 0}`}
                        </div>
                        :
                        <CircularProgress style={{ color: '#F9D100' }} />
                }
            </React.Fragment>
        )
    }
}